import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import { useSelector } from 'react-redux';
import style from './PanoramaCompass.module.scss';
function PanoramaCompass(t0) {
  const $ = _c(27);
  const {
    className,
    panoramaY
  } = t0;
  const forBtns = useSelector(_temp);
  let t1;
  if ($[0] !== forBtns[0].active || $[1] !== forBtns[1] || $[2] !== panoramaY[0] || $[3] !== panoramaY[1] || $[4] !== panoramaY[2]) {
    t1 = () => {
      if (forBtns[0].active) {
        return panoramaY[0] * -1 + 80;
      }
      if (forBtns[1].active) {
        return panoramaY[1] * -1 + 80;
      }
      return panoramaY[2] * -1 + 80;
    };
    $[0] = forBtns[0].active;
    $[1] = forBtns[1];
    $[2] = panoramaY[0];
    $[3] = panoramaY[1];
    $[4] = panoramaY[2];
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const currPanoramaY = t1;
  let t2;
  if ($[6] !== className) {
    t2 = cn(className, style.svg);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className={style.north} width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.1 15.22C4.15333 15.22 3.32667 14.9867 2.62 14.52C1.92667 14.0533 1.40667 13.4333 1.06 12.66C0.833333 12.1667 0.68 11.5467 0.6 10.8C0.52 10.0533 0.48 9.12 0.48 8C0.48 6.85333 0.513333 5.91333 0.58 5.18C0.66 4.44667 0.82 3.83333 1.06 3.34C1.42 2.56667 1.94667 1.94667 2.64 1.48C3.33333 1.01333 4.15333 0.779999 5.1 0.779999C5.99333 0.779999 6.77333 0.966666 7.44 1.34C8.12 1.71333 8.64 2.23333 9 2.9C9.37333 3.55333 9.56 4.29333 9.56 5.12C9.56 5.22667 9.52 5.32 9.44 5.4C9.36 5.48 9.26667 5.52 9.16 5.52H8.34C8.23333 5.52 8.14 5.48 8.06 5.4C7.98 5.32 7.94 5.22667 7.94 5.12C7.94 4.30667 7.68667 3.64667 7.18 3.14C6.67333 2.62 5.98 2.36 5.1 2.36C4.52667 2.36 4.00667 2.51333 3.54 2.82C3.07333 3.11333 2.72 3.55333 2.48 4.14C2.32 4.52667 2.21333 5.04 2.16 5.68C2.12 6.32 2.1 7.09333 2.1 8C2.1 8.94667 2.12 9.73333 2.16 10.36C2.21333 10.9733 2.32 11.4733 2.48 11.86C2.73333 12.4467 3.09333 12.8933 3.56 13.2C4.02667 13.4933 4.54 13.64 5.1 13.64C5.98 13.64 6.67333 13.3867 7.18 12.88C7.68667 12.36 7.94 11.6933 7.94 10.88C7.94 10.7733 7.98 10.68 8.06 10.6C8.14 10.52 8.23333 10.48 8.34 10.48H9.16C9.26667 10.48 9.36 10.52 9.44 10.6C9.52 10.68 9.56 10.7733 9.56 10.88C9.56 11.7067 9.37333 12.4533 9 13.12C8.64 13.7733 8.12 14.2867 7.44 14.66C6.77333 15.0333 5.99333 15.22 5.1 15.22Z" fill="white" /></svg>;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg className={style.east} width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.554 10C0.479333 10 0.414 9.972 0.358 9.916C0.302 9.86 0.274 9.79467 0.274 9.72V0.48C0.274 0.405333 0.302 0.34 0.358 0.284C0.414 0.228 0.479333 0.199999 0.554 0.199999H3.116C3.60133 0.199999 4.04467 0.316666 4.446 0.55C4.85667 0.774 5.17867 1.08667 5.412 1.488C5.64533 1.88 5.762 2.32333 5.762 2.818C5.762 3.16333 5.68267 3.504 5.524 3.84C5.37467 4.16667 5.16467 4.44667 4.894 4.68C4.838 4.71733 4.81 4.76867 4.81 4.834C4.81 4.89 4.838 4.94133 4.894 4.988C5.21133 5.22133 5.46333 5.534 5.65 5.926C5.846 6.30867 5.944 6.71 5.944 7.13C5.944 7.662 5.818 8.14733 5.566 8.586C5.314 9.02467 4.96867 9.37 4.53 9.622C4.10067 9.874 3.62933 10 3.116 10H0.554ZM1.352 8.782C1.352 8.87533 1.39867 8.922 1.492 8.922H3.102C3.58733 8.922 3.99333 8.74933 4.32 8.404C4.656 8.05867 4.824 7.63867 4.824 7.144C4.824 6.65867 4.656 6.248 4.32 5.912C3.99333 5.56667 3.58733 5.394 3.102 5.394H1.492C1.39867 5.394 1.352 5.44067 1.352 5.534V8.782ZM1.352 4.218C1.352 4.31133 1.39867 4.358 1.492 4.358H3.144C3.564 4.358 3.91867 4.20867 4.208 3.91C4.49733 3.61133 4.642 3.24733 4.642 2.818C4.642 2.38867 4.49733 2.02467 4.208 1.726C3.91867 1.418 3.564 1.264 3.144 1.264H1.492C1.39867 1.264 1.352 1.31067 1.352 1.404V4.218Z" fill="white" /></svg>;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg className={style.south} width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.79 10.154C5.16467 10.154 4.62333 9.99067 4.166 9.664C3.70867 9.33733 3.36333 8.90333 3.13 8.362C2.99 8.054 2.89667 7.68067 2.85 7.242C2.80333 6.794 2.77533 6.234 2.766 5.562H1.366V9.72C1.366 9.79467 1.338 9.86 1.282 9.916C1.226 9.972 1.16067 10 1.086 10H0.554C0.479333 10 0.414 9.972 0.358 9.916C0.302 9.86 0.274 9.79467 0.274 9.72V0.48C0.274 0.405333 0.302 0.34 0.358 0.284C0.414 0.228 0.479333 0.199999 0.554 0.199999H1.086C1.16067 0.199999 1.226 0.228 1.282 0.284C1.338 0.34 1.366 0.405333 1.366 0.48V4.47H2.766C2.77533 3.86333 2.80333 3.34533 2.85 2.916C2.906 2.48667 2.99933 2.12733 3.13 1.838C3.36333 1.29667 3.70867 0.862666 4.166 0.535999C4.62333 0.209333 5.16467 0.0459996 5.79 0.0459996C6.406 0.0459996 6.94267 0.209333 7.4 0.535999C7.85733 0.862666 8.20267 1.29667 8.436 1.838C8.58533 2.18333 8.68333 2.608 8.73 3.112C8.77667 3.616 8.8 4.27867 8.8 5.1C8.8 5.92133 8.77667 6.584 8.73 7.088C8.68333 7.592 8.58533 8.01667 8.436 8.362C8.20267 8.90333 7.85733 9.33733 7.4 9.664C6.94267 9.99067 6.406 10.154 5.79 10.154ZM3.9 5.1C3.9 5.79067 3.90933 6.346 3.928 6.766C3.956 7.186 4.01667 7.53133 4.11 7.802C4.26867 8.21267 4.49267 8.52533 4.782 8.74C5.08067 8.94533 5.41667 9.048 5.79 9.048C6.154 9.048 6.48067 8.94533 6.77 8.74C7.06867 8.52533 7.29733 8.21267 7.456 7.802C7.54933 7.53133 7.60533 7.186 7.624 6.766C7.652 6.346 7.666 5.79067 7.666 5.1C7.666 4.4 7.652 3.84467 7.624 3.434C7.60533 3.014 7.54933 2.66867 7.456 2.398C7.29733 1.98733 7.06867 1.67933 6.77 1.474C6.48067 1.25933 6.154 1.152 5.79 1.152C5.41667 1.152 5.08067 1.25933 4.782 1.474C4.49267 1.67933 4.26867 1.98733 4.11 2.398C4.01667 2.66867 3.956 3.014 3.928 3.434C3.90933 3.84467 3.9 4.4 3.9 5.1Z" fill="white" /></svg>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className={style.west} width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.71 10.154C3.08467 10.154 2.54333 10.028 2.086 9.776C1.638 9.51467 1.29267 9.16 1.05 8.712C0.816667 8.264 0.7 7.76 0.7 7.2V7.102C0.7 7.02733 0.728 6.962 0.784 6.906C0.84 6.85 0.905333 6.822 0.98 6.822H1.498C1.57267 6.822 1.638 6.85 1.694 6.906C1.75 6.962 1.778 7.02733 1.778 7.102V7.2C1.778 7.732 1.95067 8.18 2.296 8.544C2.65067 8.89867 3.122 9.076 3.71 9.076C4.28867 9.076 4.73667 8.89867 5.054 8.544C5.38067 8.18933 5.544 7.74133 5.544 7.2C5.544 6.696 5.39 6.276 5.082 5.94C4.774 5.59467 4.31667 5.422 3.71 5.422H3.206C3.13133 5.422 3.066 5.394 3.01 5.338C2.954 5.282 2.926 5.21667 2.926 5.142V4.638C2.926 4.56333 2.954 4.498 3.01 4.442C3.066 4.386 3.13133 4.358 3.206 4.358H3.71C4.214 4.358 4.61067 4.204 4.9 3.896C5.19867 3.588 5.348 3.20067 5.348 2.734C5.348 2.27667 5.208 1.894 4.928 1.586C4.65733 1.278 4.25133 1.124 3.71 1.124C3.14067 1.124 2.70667 1.292 2.408 1.628C2.11867 1.95467 1.974 2.34667 1.974 2.804V3C1.974 3.07467 1.946 3.14 1.89 3.196C1.834 3.252 1.76867 3.28 1.694 3.28H1.176C1.10133 3.28 1.036 3.252 0.98 3.196C0.924 3.14 0.896 3.07467 0.896 3V2.804C0.896 2.28133 1.008 1.81467 1.232 1.404C1.46533 0.984 1.792 0.652666 2.212 0.409999C2.64133 0.167333 3.14067 0.0459996 3.71 0.0459996C4.27 0.0459996 4.75533 0.162666 5.166 0.395999C5.57667 0.629333 5.88933 0.951333 6.104 1.362C6.328 1.77267 6.44 2.23 6.44 2.734C6.44 3.126 6.37 3.49467 6.23 3.84C6.09 4.176 5.88933 4.46067 5.628 4.694C5.56267 4.75933 5.53 4.81533 5.53 4.862C5.53 4.918 5.558 4.96933 5.614 5.016C5.93133 5.28667 6.17867 5.61333 6.356 5.996C6.54267 6.37867 6.636 6.78467 6.636 7.214C6.636 7.76467 6.51467 8.264 6.272 8.712C6.03867 9.16 5.698 9.51467 5.25 9.776C4.81133 10.028 4.298 10.154 3.71 10.154Z" fill="white" /></svg>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = `rotate(${currPanoramaY()}deg)`;
  let t8;
  if ($[12] !== t7) {
    t8 = {
      transform: t7
    };
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t10;
  let t11;
  let t12;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <circle cx="42.2806" cy="42.7072" r="24.5" transform="rotate(135 42.2806 42.7072)" stroke="white" />;
    t10 = <path d="M42.2806 82.3051L42.2806 42" stroke="white" strokeWidth="4" />;
    t11 = <path d="M82.5858 42H71.272M1.97558 42H66.7954" stroke="white" />;
    t12 = <path d="M42.2806 82.3051L42.2806 1.69494" stroke="white" />;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
    $[17] = t9;
  } else {
    t10 = $[14];
    t11 = $[15];
    t12 = $[16];
    t9 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <g clipPath="url(#clip0_2283_35273)"><path d="M74.4296 44.943L73.2579 44.5015" stroke="white" strokeWidth="0.954023" strokeLinecap="round" strokeLinejoin="round" /><path d="M74.2225 38.5573L73.0818 39.0737" stroke="white" strokeWidth="0.954023" strokeLinecap="round" strokeLinejoin="round" /><path d="M69.5609 34.1882L69.1194 35.36" stroke="white" strokeWidth="0.954023" strokeLinecap="round" strokeLinejoin="round" /><path d="M70.0605 49.6047L69.5441 48.464" stroke="white" strokeWidth="0.954023" strokeLinecap="round" strokeLinejoin="round" /><path d="M68.585 46.3456C70.985 45.2591 72.0498 42.4328 70.9633 40.0328C70.1092 38.1459 68.1796 37.0844 66.2273 37.2446C66.9998 39.9457 66.7325 44.7202 66.5023 46.7698C67.1981 46.7872 67.9085 46.6519 68.585 46.3456Z" stroke="white" strokeWidth="0.954023" strokeLinejoin="round" /></g>;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <g clipPath="url(#clip1_2283_35273)"><path d="M10.433 38.5013L11.5698 39.0261" stroke="white" strokeWidth="0.954023" strokeLinecap="round" strokeLinejoin="round" /><path d="M10.179 44.8853L11.3539 44.4525" stroke="white" strokeWidth="0.954023" strokeLinecap="round" strokeLinejoin="round" /><path d="M14.5134 49.5792L15.0382 48.4423" stroke="white" strokeWidth="0.954023" strokeLinecap="round" strokeLinejoin="round" /><path d="M15.127 34.1668L15.5597 35.3418" stroke="white" strokeWidth="0.954023" strokeLinecap="round" strokeLinejoin="round" /><path d="M16.3635 37.5239C13.8914 38.4344 12.6255 41.1766 13.536 43.6487C14.2519 45.5922 16.0999 46.7902 18.0586 46.7712C17.483 44.0214 18.0939 39.2786 18.4714 37.2509C17.7787 37.1834 17.0603 37.2672 16.3635 37.5239Z" fill="white" stroke="white" strokeWidth="0.954023" strokeLinejoin="round" /></g>;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <clipPath id="clip0_2283_35273"><rect width="19.0805" height="19.0805" fill="white" transform="translate(79.2434 46.7566) rotate(155.643)" /></clipPath>;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <defs>{t15}<clipPath id="clip1_2283_35273"><rect width="19.0805" height="19.0805" fill="white" transform="translate(5.76251 36.3452) rotate(-20.2205)" /></clipPath></defs>;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t8) {
    t17 = <svg style={t8} width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">{t9}{t10}{t11}{t12}{t13}{t14}{t16}</svg>;
    $[22] = t8;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== t17 || $[25] !== t2) {
    t18 = <span className={t2}>{t3}{t4}{t5}{t6}{t17}</span>;
    $[24] = t17;
    $[25] = t2;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  return t18;
}
function _temp(state) {
  return state.projectinfo.panoramas;
}
export default PanoramaCompass;